import { render, staticRenderFns } from "./ClientFormModal.vue?vue&type=template&id=20aff044"
import script from "./ClientFormModal.vue?vue&type=script&lang=js"
export * from "./ClientFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClientFormModal.vue?vue&type=style&index=0&id=20aff044&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20aff044')) {
      api.createRecord('20aff044', component.options)
    } else {
      api.reload('20aff044', component.options)
    }
    module.hot.accept("./ClientFormModal.vue?vue&type=template&id=20aff044", function () {
      api.rerender('20aff044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/ClientFormModal.vue"
export default component.exports